import { colors } from 'fitify-ui'
import { styled } from 'styled-components'

import { StyledForm } from 'components/Form/Form.Styled'

export const StyledContainer = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Graphik LCG Web', sans-serif;
  gap: 32px;
`

export const StyledHeading = styled.h1`
  color: ${colors.Black};
  font-family: 'Graphik LCG Web', sans-serif;
  font-size: 48px;
  font-weight: 600;
`

export const StyledLoginForm = styled(StyledForm)`
  display: flex;
  max-width: 400px;
  flex-direction: column;
`
